export default __webpack_public_path__ + "static/media/Moon.d17ba5b1.png";